function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import styled from 'styled-components';
import { fontStyle, spacing } from '@naf/theme';
import { Text, TextVariant } from '@naf/text';
import { Tooltip } from '@naf/parts';
import { propValidationConfig } from '../propValidationConfig';
export const Label = ({
  children,
  toolTip,
  htmlFor,
  subHeader,
  width = 256,
  className,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(Title, _extends({
    className: className,
    htmlFor: htmlFor,
    width: width
  }, rest), /*#__PURE__*/React.createElement(TitleWrap, null, /*#__PURE__*/React.createElement(TitleText, {
    variant: TextVariant.Small
  }, children), toolTip && /*#__PURE__*/React.createElement(Tooltip, {
    text: toolTip
  })), subHeader && /*#__PURE__*/React.createElement(Helper, null, subHeader));
};
export default Label;
const Title = styled.label.withConfig(propValidationConfig).withConfig({
  displayName: "label__Title",
  componentId: "sc-x746im-0"
})(["display:flex;flex-wrap:wrap;margin-bottom:", ";width:", "px;"], spacing.space8, props => props.width);
const TitleWrap = styled.div.withConfig({
  displayName: "label__TitleWrap",
  componentId: "sc-x746im-1"
})(["display:flex;align-items:flex-end;flex-basis:100%;margin:0;position:relative;"]);
const TitleText = styled(Text).withConfig({
  displayName: "label__TitleText",
  componentId: "sc-x746im-2"
})(["margin:0 ", " 0 0;line-height:", ";"], spacing.space8, spacing.space16);
const Helper = styled.h6.withConfig({
  displayName: "label__Helper",
  componentId: "sc-x746im-3"
})(["margin:", " 0 0;", ";line-height:", ";flex-basis:100%;"], spacing.space4, fontStyle.article.caption, spacing.space16);
//# sourceMappingURL=label.js.map